import React from 'react';
import EventTag from './eventTag';

const EventItem = (props) => {
  const { event } = props;

  let locationString;

  if (
    event.city !== '' &&
    event.state !== '' &&
    event.country !== ''
  ) {
    locationString = `${event.city}, ${event.state}, ${event.country}`
  } else {
    locationString = `${event.city ? `${event.city}, ` : ''} ${event.country}`
  }

  return (
    <li className="timeline-item">
        <div className="timeline-info">
            <span>{event.date}</span>
        </div>
        <div className="timeline-marker"></div>
        <div className="timeline-content">
            <h3 className="timeline-title">
              {
                event.link
                  ? <a className="event-link" href={event.link} target="blank">{event.name}</a>
                  : event.name
              }
            </h3>
            <p>{locationString}</p>
            <p>
              Estimated Audience: {event.estimated_audience}
            </p>
            <div className="item-tags">
              { event.awards ? <EventTag tag="awards" /> : null }
              { event.community_outreach ? <EventTag tag="community_outreach" /> : null }
              { event.dignitary_meetings ? <EventTag tag="dignitary_meetings" /> : null }
              { event.interviews ? <EventTag tag="interviews" /> : null }
              { event.keynote_speech ? <EventTag tag="keynote_speech" /> : null }
              { event.videos ? <EventTag tag="videos" /> : null }
              { event.volunteer_work ? <EventTag tag="volunteer_work" /> : null }
            </div>
        </div>
    </li>
  );
}

export default EventItem;
